var _excluded = ["file_path"];
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var fs = require('fs');
var path = require('path');
var _require = require('./chain-database'),
  ChainDatabase = _require.ChainDatabase;
var _require2 = require('./chain-files'),
  readBlockMetadata = _require2.readBlockMetadata,
  blockFiles = _require2.blockFiles,
  BLOCK_NAME = _require2.BLOCK_NAME;
var HASH = /^[a-f0-9]{64}$/i;
function height(value) {
  if (!/^\d+$/.test(String(value))) throw new Error('Invalid block height');
  var result = Number(value);
  if (!Number.isSafeInteger(result) || result < 1) throw new Error('Invalid block height');
  return result;
}
var ChainIndex = /*#__PURE__*/function () {
  function ChainIndex(app, mod) {
    _classCallCheck(this, ChainIndex);
    this.app = app;
    this.mod = mod;
    this.directory = path.join(app.storage.data_dir, 'blocks');
    this.hashBytes = function (bytes) {
      return Buffer.from(app.crypto.hash(bytes), 'hex');
    };
    this.scan = null;
    this.scanBusy = null;
    this.scanned = 0;
    this.scanErrors = 0;
    this.scanComplete = false;
    this.scanFinishedAt = 0;
    this.rangeJobs = new Map();
    this.revision = 0;
  }
  return _createClass(ChainIndex, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _t = ChainDatabase;
              _context.n = 1;
              return this.app.storage.returnDatabaseByName(this.mod.dbname);
            case 1:
              _t2 = _context.v;
              this.database = new _t(_t2);
              _context.n = 2;
              return this.database.db.exec('PRAGMA busy_timeout = 5000');
            case 2:
              _context.n = 3;
              return this.database.initialize();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize() {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "observe",
    value: function () {
      var _observe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(block) {
        var _block$instance;
        var lc,
          id,
          hash,
          existing,
          record,
          name,
          _args2 = arguments,
          _t3,
          _t4,
          _t5;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              lc = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              id = height(block.id);
              hash = String(block.hash);
              if (HASH.test(hash)) {
                _context2.n = 1;
                break;
              }
              throw new Error('Invalid block hash');
            case 1:
              _context2.n = 2;
              return this.database.get(hash);
            case 2:
              existing = _context2.v;
              record = {
                hash: hash,
                height: id,
                parent_hash: String(block.previousBlockHash),
                timestamp: Number(block.timestamp),
                creator: String(block.creator || ((_block$instance = block.instance) === null || _block$instance === void 0 ? void 0 : _block$instance.creator) || ''),
                in_longest_chain: lc == null ? null : lc ? 1 : 0
              };
              if (!(!(existing !== null && existing !== void 0 && existing.size_bytes) || !(existing !== null && existing !== void 0 && existing.body_available))) {
                _context2.n = 6;
                break;
              }
              name = String(block.file_name || '');
              if (!(BLOCK_NAME.test(name) && path.basename(name) === name)) {
                _context2.n = 6;
                break;
              }
              _context2.p = 3;
              _t3 = Object;
              _t4 = record;
              _context2.n = 4;
              return readBlockMetadata(path.join(this.directory, name), this.hashBytes);
            case 4:
              _t3.assign.call(_t3, _t4, _context2.v);
              record.in_longest_chain = lc == null ? null : lc ? 1 : 0;
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t5 = _context2.v;
              if (_t5.code !== 'ENOENT') console.warn('Explorer chain metadata:', _t5.message);
            case 6:
              _context2.n = 7;
              return this.database.put(record);
            case 7:
              return _context2.a(2, this.database.get(hash));
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function observe(_x) {
        return _observe.apply(this, arguments);
      }
      return observe;
    }()
  }, {
    key: "reorganize",
    value: function () {
      var _reorganize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(hash, lc) {
        var _t6, _t7;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.revision++;
              // Reorg callbacks may precede onNewBlock; keep the status even in that case.
              _context3.n = 1;
              return this.database.get(hash);
            case 1:
              if (_context3.v) {
                _context3.n = 6;
                break;
              }
              _context3.p = 2;
              _t6 = this;
              _context3.n = 3;
              return this.app.core.blockchain.getBlock(hash, false);
            case 3:
              _context3.n = 4;
              return _t6.observe.call(_t6, _context3.v);
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t7 = _context3.v;
            case 6:
              _context3.n = 7;
              return this.database.status(hash, lc);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 5]]);
      }));
      function reorganize(_x2, _x3) {
        return _reorganize.apply(this, arguments);
      }
      return reorganize;
    }()
  }, {
    key: "scanBatch",
    value: function () {
      var _scanBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!this.scanBusy) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, this.scanBusy);
            case 1:
              if (!(this.scanComplete && Date.now() - this.scanFinishedAt < 60000)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              this.scanBusy = this.scanNextFiles();
              _context4.p = 3;
              _context4.n = 4;
              return this.scanBusy;
            case 4:
              _context4.p = 4;
              this.scanBusy = null;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[3,, 4, 5]]);
      }));
      function scanBatch() {
        return _scanBatch.apply(this, arguments);
      }
      return scanBatch;
    }()
  }, {
    key: "scanNextFiles",
    value: function () {
      var _scanNextFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var start, i, next, filename, stat, _err$code, _this$scan, _t8, _t9, _t0;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!this.scan) {
                this.scan = blockFiles(this.directory);
                this.scanComplete = false;
                this.scanned = 0;
                this.scanErrors = 0;
              }
              start = Date.now();
              _context5.p = 1;
              i = 0;
            case 2:
              if (!(i < 64 && Date.now() - start < 150)) {
                _context5.n = 15;
                break;
              }
              _context5.n = 3;
              return this.scan.next();
            case 3:
              next = _context5.v;
              if (!next.done) {
                _context5.n = 4;
                break;
              }
              this.scan = null;
              this.scanComplete = true;
              this.scanFinishedAt = Date.now();
              return _context5.a(3, 15);
            case 4:
              filename = next.value;
              this.scanned++;
              _context5.p = 5;
              _context5.n = 6;
              return fs.promises.stat(filename);
            case 6:
              stat = _context5.v;
              _context5.n = 7;
              return this.database.fileSeen(filename, stat);
            case 7:
              if (!_context5.v) {
                _context5.n = 8;
                break;
              }
              return _context5.a(3, 14);
            case 8:
              _t8 = this.database;
              _context5.n = 9;
              return readBlockMetadata(filename, this.hashBytes);
            case 9:
              _context5.n = 10;
              return _t8.put.call(_t8, _context5.v);
            case 10:
              _context5.n = 11;
              return this.database.rememberFile(filename, stat);
            case 11:
              _context5.n = 14;
              break;
            case 12:
              _context5.p = 12;
              _t9 = _context5.v;
              if (!((_err$code = _t9.code) !== null && _err$code !== void 0 && _err$code.startsWith('SQLITE'))) {
                _context5.n = 13;
                break;
              }
              throw _t9;
            case 13:
              this.scanErrors++;
              console.warn('Explorer chain scan:', filename, _t9.message);
            case 14:
              i++;
              _context5.n = 2;
              break;
            case 15:
              _context5.n = 18;
              break;
            case 16:
              _context5.p = 16;
              _t0 = _context5.v;
              _context5.n = 17;
              return (_this$scan = this.scan) === null || _this$scan === void 0 ? void 0 : _this$scan["return"]();
            case 17:
              this.scan = null;
              console.warn('Explorer chain scan failed:', _t0.message);
              throw new Error('Unable to index local block files');
            case 18:
              return _context5.a(2);
          }
        }, _callee5, this, [[5, 12], [1, 16]]);
      }));
      function scanNextFiles() {
        return _scanNextFiles.apply(this, arguments);
      }
      return scanNextFiles;
    }()
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(identifier) {
        var hash, block, id, _block, _t1, _t10;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(identifier && HASH.test(String(identifier)))) {
                _context6.n = 5;
                break;
              }
              hash = String(identifier).toLowerCase();
              _context6.p = 1;
              _context6.n = 2;
              return this.app.core.blockchain.getBlock(hash, false);
            case 2:
              block = _context6.v;
              _context6.n = 3;
              return this.observe(block, block.inLongestChain);
            case 3:
              return _context6.a(2, _context6.v);
            case 4:
              _context6.p = 4;
              _t1 = _context6.v;
              return _context6.a(2, this.database.get(hash));
            case 5:
              id = height(identifier);
              _context6.p = 6;
              _context6.n = 7;
              return this.app.core.blockchain.getBlock(BigInt(id), false);
            case 7:
              _block = _context6.v;
              _context6.n = 8;
              return this.observe(_block, _block.inLongestChain);
            case 8:
              return _context6.a(2, _context6.v);
            case 9:
              _context6.p = 9;
              _t10 = _context6.v;
              return _context6.a(2, this.database.getAtHeight(id));
          }
        }, _callee6, this, [[6, 9], [1, 4]]);
      }));
      function resolve(_x4) {
        return _resolve.apply(this, arguments);
      }
      return resolve;
    }()
  }, {
    key: "range",
    value: function () {
      var _range = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var params,
          from,
          to,
          afterHeight,
          afterHash,
          key,
          job,
          _args7 = arguments;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              params = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};
              // Validate before doing disk or core work. Continue within a height when a
              // response hits the row limit; siblings can never silently disappear.
              from = params.from == null ? null : height(params.from);
              to = params.to == null ? null : height(params.to);
              if (!(from == null !== (to == null) || from != null && (to < from || to - from > 49))) {
                _context7.n = 1;
                break;
              }
              throw new Error('Request at most 50 consecutive heights');
            case 1:
              afterHeight = params.after_height == null ? 0 : height(params.after_height);
              afterHash = params.after_hash || '';
              if (!(afterHash && !HASH.test(afterHash))) {
                _context7.n = 2;
                break;
              }
              throw new Error('Invalid continuation hash');
            case 2:
              if (params.anchor && !HASH.test(String(params.anchor))) height(params.anchor);
              key = JSON.stringify([from, to, params.anchor, afterHeight, afterHash]);
              if (!this.rangeJobs.has(key)) {
                _context7.n = 3;
                break;
              }
              return _context7.a(2, this.rangeJobs.get(key));
            case 3:
              if (!(this.rangeJobs.size >= 2)) {
                _context7.n = 4;
                break;
              }
              throw new Error('Chain viewer is busy; retry shortly');
            case 4:
              job = this.loadRange({
                from: from,
                to: to,
                anchor: params.anchor,
                afterHeight: afterHeight,
                afterHash: afterHash
              });
              this.rangeJobs.set(key, job);
              _context7.p = 5;
              _context7.n = 6;
              return job;
            case 6:
              return _context7.a(2, _context7.v);
            case 7:
              _context7.p = 7;
              this.rangeJobs["delete"](key);
              return _context7.f(7);
            case 8:
              return _context7.a(2);
          }
        }, _callee7, this, [[5,, 7, 8]]);
      }));
      function range() {
        return _range.apply(this, arguments);
      }
      return range;
    }()
  }, {
    key: "loadRange",
    value: function () {
      var _loadRange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref) {
        var _center$height, _center2, _center$hash, _center3;
        var from, to, anchor, afterHeight, afterHash, chain, tip, center, diskError, bounds, _center, _tip, id, _id, hashes, _iterator, _step, hash, block, rows, more, page, last, _t11, _t12, _t13, _t14, _t15;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              from = _ref.from, to = _ref.to, anchor = _ref.anchor, afterHeight = _ref.afterHeight, afterHash = _ref.afterHash;
              chain = this.app.core.blockchain;
              tip = null;
              _context8.p = 1;
              _context8.n = 2;
              return chain.getBlocks(1, false);
            case 2:
              tip = _context8.v[0];
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t11 = _context8.v;
            case 4:
              if (!(from == null && anchor)) {
                _context8.n = 6;
                break;
              }
              _context8.n = 5;
              return this.resolve(anchor);
            case 5:
              center = _context8.v;
            case 6:
              diskError = null;
              if (afterHeight) {
                _context8.n = 10;
                break;
              }
              _context8.p = 7;
              _context8.n = 8;
              return this.scanBatch();
            case 8:
              _context8.n = 10;
              break;
            case 9:
              _context8.p = 9;
              _t12 = _context8.v;
              diskError = _t12.message;
            case 10:
              if (!(from == null && anchor && !center)) {
                _context8.n = 12;
                break;
              }
              _context8.n = 11;
              return this.resolve(anchor);
            case 11:
              center = _context8.v;
            case 12:
              _context8.n = 13;
              return this.database.bounds();
            case 13:
              bounds = _context8.v;
              if (!(from == null)) {
                _context8.n = 15;
                break;
              }
              if (!(anchor && !center)) {
                _context8.n = 14;
                break;
              }
              return _context8.a(2, {
                blocks: [],
                pending_anchor: !this.scanComplete,
                anchor_missing: this.scanComplete,
                indexing: !this.scanComplete,
                scanned_files: this.scanned,
                disk_error: diskError
              });
            case 14:
              id = height(((_center = center) === null || _center === void 0 ? void 0 : _center.height) || ((_tip = tip) === null || _tip === void 0 ? void 0 : _tip.id) || bounds.newest || 1);
              from = Math.max(1, id - 24);
              to = Math.min(Number.MAX_SAFE_INTEGER, from + 49);
            case 15:
              _id = from;
            case 16:
              if (!(!afterHeight && _id <= to)) {
                _context8.n = 32;
                break;
              }
              hashes = [];
              _context8.p = 17;
              _context8.n = 18;
              return chain.getHashesAtId(BigInt(_id));
            case 18:
              hashes = _context8.v;
              _context8.n = 20;
              break;
            case 19:
              _context8.p = 19;
              _t13 = _context8.v;
            case 20:
              _iterator = _createForOfIteratorHelper(hashes);
              _context8.p = 21;
              _iterator.s();
            case 22:
              if ((_step = _iterator.n()).done) {
                _context8.n = 28;
                break;
              }
              hash = _step.value;
              _context8.p = 23;
              _context8.n = 24;
              return chain.getBlock(String(hash), false);
            case 24:
              block = _context8.v;
              _context8.n = 25;
              return this.observe(block, block.inLongestChain);
            case 25:
              _context8.n = 27;
              break;
            case 26:
              _context8.p = 26;
              _t14 = _context8.v;
              console.warn('Explorer chain observation:', _t14.message);
            case 27:
              _context8.n = 22;
              break;
            case 28:
              _context8.n = 30;
              break;
            case 29:
              _context8.p = 29;
              _t15 = _context8.v;
              _iterator.e(_t15);
            case 30:
              _context8.p = 30;
              _iterator.f();
              return _context8.f(30);
            case 31:
              _id++;
              _context8.n = 16;
              break;
            case 32:
              _context8.n = 33;
              return this.database.reconcileAncestors(from, to);
            case 33:
              _context8.n = 34;
              return this.database.range(from, to, afterHeight, afterHash);
            case 34:
              rows = _context8.v;
              more = rows.length > 500;
              page = rows.slice(0, 500);
              last = page[page.length - 1];
              return _context8.a(2, {
                blocks: page.map(function (_ref2) {
                  var file_path = _ref2.file_path,
                    row = _objectWithoutProperties(_ref2, _excluded);
                  return row;
                }),
                from: from,
                to: to,
                center: (_center$height = (_center2 = center) === null || _center2 === void 0 ? void 0 : _center2.height) !== null && _center$height !== void 0 ? _center$height : null,
                selected_hash: (_center$hash = (_center3 = center) === null || _center3 === void 0 ? void 0 : _center3.hash) !== null && _center$hash !== void 0 ? _center$hash : null,
                tip_height: tip ? Number(tip.id) : bounds.newest,
                tip_hash: tip ? String(tip.hash) : null,
                revision: this.revision,
                oldest_indexed: bounds.oldest,
                indexing: !this.scanComplete,
                scanned_files: this.scanned,
                scan_errors: this.scanErrors,
                disk_error: diskError,
                continuation: more ? {
                  after_height: last.height,
                  after_hash: last.hash
                } : null
              });
          }
        }, _callee8, this, [[23, 26], [21, 29, 30, 31], [17, 19], [7, 9], [1, 3]]);
      }));
      function loadRange(_x5) {
        return _loadRange.apply(this, arguments);
      }
      return loadRange;
    }()
  }, {
    key: "loadStoredBlock",
    value: function () {
      var _loadStoredBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(identifier, includeTransactions) {
        var row, block;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.resolve(identifier);
            case 1:
              row = _context9.v;
              if (row) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, null);
            case 2:
              if (!(includeTransactions && row.file_path)) {
                _context9.n = 5;
                break;
              }
              _context9.n = 3;
              return this.app.storage.loadBlockByFilename(row.file_path);
            case 3:
              block = _context9.v;
              if (!(block && String(block.hash) === row.hash)) {
                _context9.n = 4;
                break;
              }
              return _context9.a(2, {
                block: block,
                row: row
              });
            case 4:
              _context9.n = 5;
              return this.database.db.run('UPDATE explorer_chain_blocks SET body_available = 0 WHERE hash = ?', row.hash);
            case 5:
              return _context9.a(2, {
                row: row
              });
          }
        }, _callee9, this);
      }));
      function loadStoredBlock(_x6, _x7) {
        return _loadStoredBlock.apply(this, arguments);
      }
      return loadStoredBlock;
    }()
  }]);
}();
module.exports = {
  ChainIndex: ChainIndex,
  height: height
};